module.exports = __webpack_public_path__ + "media/images/img_service_step_1-0533999c226c3de8f0f3867713944701.png";